module.exports = __webpack_public_path__ + "static/media/romanian_sm79.95b0ba8f.png";